import React, { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { listESP32SensorData, listBloodPressureData } from './graphql/queries';
import { ESP32SensorData, ModelSortDirection, BloodPressureData } from './API'
import SensorDataChart from './SensorDataChart';
import BloodPressureDataChart from './BloodPressureDataChart';

const client = generateClient();


const HealthChart = () => {
    const [sensorData, setSensorData] = useState<ESP32SensorData[]>([]);
    const [bloodPressureData, setBloodPressureData] = useState<BloodPressureData[]>([]);

    useEffect(() => {
        fetchSensorData();
        fetchBloodPressureData();
    }, []);

    async function fetchSensorData() {
        try {
            const apiData = await client.graphql({
                query: listESP32SensorData,
                variables: {
                    device_id: 'esp32_001',
                    limit: 24,
                    sortDirection: ModelSortDirection.DESC
                }
            });
            console.log(apiData)
            const items = apiData.data.listESP32SensorData?.items ?? [];
            setSensorData(items as ESP32SensorData[]);
        } catch (err) {
            console.error('Error fetching sensor data:', err);
        }
    }

    async function fetchBloodPressureData() {
        try {
            const apiData = await client.graphql({
                query: listBloodPressureData,
                variables: {
                    device_id: 'bp_device_001',
                    limit: 20, // 获取 20 条数据
                    sortDirection: ModelSortDirection.DESC
                }
            });
            console.log(apiData)
            const items = apiData.data.listBloodPressureData?.items ?? [];
            setBloodPressureData(items as BloodPressureData[]);
        } catch (err) {
            console.error('Error fetching blood pressure data:', err);
        }
    }

    return (
        <div>
            <h1>Health Chart</h1>
            <SensorDataChart sensorData={sensorData} />
            <BloodPressureDataChart bloodPressureData={bloodPressureData} />
            {/* <ul>
                {sensorData.map((data: ESP32SensorData) => (
                    <li key={data.device_id}>
                        Device: {data.device_id}, Time: {data.timestamp}, Humidity: {data.humidity}, Pressure: {data.pressure}, Temperature: {data.temperature}
                    </li>
                ))}
            </ul> */}
        </div>
    );
};

export default HealthChart;
